<template>
  <v-form @submit.prevent="submit" ref="form">
    <v-container fluid class="company-info px-2 px-md-0">
      <v-row class="company-info-content text-md-left text-center mx-0 ml-md-5">
        <div class="d-block d-md-flex justify-space-between col-12 px-0">
          <h2 class="mb-1 mb-md-3 w-md-50 w-100 py-0 pl-0 group-label flex">
            Basic Information
          </h2>
          <!-- <div class="text-right w-md-50">
            <v-btn
              small
              color="appGreen"
              class="white--text"
              @click="showInviteModal = true"
            >
              Invite new members
              <v-icon small class="ml-2">mdi-send</v-icon>
            </v-btn>
          </div> -->
          <!-- verif -->

         
        </div>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" md="6" sm="12">
              <v-text-field
                label="Name"
                outlined
                hide-details="auto"
                v-model="surgery.name"
                disabled="true"
                :rules="surgeryRules.name"
                flat
              ></v-text-field>
            </v-col>
            <v-col sm="12" md="6">
              <v-tel-field
                label="Contact Number"
                outlined
                v-model="surgery.phone"
                :rules="surgeryRules.phone"
                hide-details="auto"
                flat
              ></v-tel-field>
              <!-- <vue-tel-input
                label="Contact Number"
                solo
                dense
                hide-details="auto"
                v-model="surgery.phone"
                :rules="surgeryRules.phone"
                flat
              ></vue-tel-input> -->
            </v-col>
            <v-col sm="6" class="d-block d-md-none"> </v-col>
          </v-row>
          <v-row>
            <!-- <v-col cols="12" sm="12" md="6">
              <v-text-field
                label="Building No"
                outlined
                hide-details="auto"
                v-model="surgery.aptNo"
                :rules="surgeryRules.aptNo"
                flat
              ></v-text-field>
            </v-col> -->
            <!-- <v-col sm="6" md="6">
              <v-text-field
                label="Contact Number"
                solo
                dense
                hide-details="auto"
                v-model="surgery.state"
                :rules="surgeryRules.state"
                flat
              ></v-text-field>
            </v-col> -->
            <v-col sm="6" class="d-block d-md-none"> </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="my-3">
          <v-divider horizontal></v-divider>
        </v-col>
        <div class="d-block d-md-flex justify-space-between w-100 align-center">
          <h2 class="group-label flex">Addresses</h2>
          <div class="text-right">
            <a href="#" @click="add">Add Address </a>
          </div>
        </div>
        <v-col cols="12">
          <v-row>
            <v-col class="py-0 d-flex justify-space-between">
              <div class="mt-8 flex">
                <div v-for="address in addresses" :key="address.id">
                  <div class="d-flex align-center justify-space-between">
                    <div class="flex font-15 w-70">
                      {{ address | formattedAddress }}
                    </div>
                    <div>
                      <!-- <v-chip
                        class="ma-2 mr-4 white--text"
                        small
                        :color="
                          address.approved == 1
                            ? '#23A0A0'
                            : address.approved == 2
                            ? '#FF7777'
                            : '#C03737'
                        "
                      >
                        {{
                          address.approved == 1
                            ? "Approved"
                            : address.approved == 2
                            ? "Pending"
                            : "Unapproved"
                        }}
                      </v-chip> -->

                      <v-btn icon small @click="openEditModal(address)">
                        <v-icon>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn icon small @click="destroy(address)">
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <v-radio-group @change="changeActive" :value="active" class="mt-0">
                <template v-for="address in addresses">
                  <v-radio
                    :key="address.id"
                    :label="address.label"
                    :value="address.id"
                    v-if="address.label !== ''"
                  ></v-radio>
                </template>
              </v-radio-group> -->
            </v-col>
          </v-row>
          <template v-for="(address, index) in addresses">
            <v-form
              :key="address.id"
              :ref="index + '-form'"
              @submit.prevent="save(address, index)"
            >
              <v-row
                class="flex-wrap company-info-content"
                :key="address.id"
                v-if="address.active"
              >
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.address"
                    :rules="addressRules"
                    label="Address"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="address.city"
                    :rules="cityRules"
                    label="City"
                    solo
                    flat
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="address.postcode"
                    :rules="postcodeRules"
                    label="Postcode"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" md="6">
                  <v-select
                    v-model="address.countryId"
                    :items="countries"
                    :rules="countryRules"
                    label="Country"
                    solo
                    flat
                    dense
                    value
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.aptNo"
                    :rules="aptNoRules"
                    label="Building No"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.state"
                    :rules="stateRules"
                    label="State"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
              <v-btn
                v-if="address.active"
                class="mr-2"
                :key="address.id"
                color="#23A0A0"
                dark
                type="submit"
                >Save</v-btn
              >
            </v-form>
          </template>
        </v-col>
        <!-- <v-col cols="12" class="my-3">
          <v-divider horizontal></v-divider>
        </v-col>
        <h2 class="my-3">Notification</h2>
        <v-col cols="12" class="notifications">
          <v-row>
            <v-col cols="12">
              <v-checkbox
                label="I want to Received Dentoholic's Email"
                hide-details="auto"
                color="black"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox label="Push Notifications" color="black"></v-checkbox>
            </v-col>
          </v-row>
        </v-col> -->
      </v-row>
      <div class="mt-5 d-flex justify-end ">
        <v-btn
          :block="$vuetify.breakpoint.mobile"
          type="submit"
          color="appRed"
          class="white--text d-block d-md-inline-block"
          >Save</v-btn
        >
      </div>
    </v-container>
    <v-dialog v-model="showAddModal" width="800">
      <v-form ref="addressCreateForm" @submit.prevent="createAddress">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Create Address</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.address"
                    :rules="addressRules"
                    label="Address"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="address.city"
                    :rules="cityRules"
                    label="City"
                    solo
                    flat
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="address.postcode"
                    :rules="postcodeRules"
                    label="Postcode"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" md="6" @click.stop>
                  <v-select
                    v-model="address.countryId"
                    :items="countries"
                    :rules="countryRules"
                    label="Country"
                    solo
                    flat
                    dense
                    value
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.aptNo"
                    :rules="aptNoRules"
                    label="Building No"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.state"
                    :rules="stateRules"
                    label="State"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="appGreen darken-1" dark type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="showEditModal" width="800">
      <v-form ref="addressEditForm" @submit.prevent="editAddress">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Update Address</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.address"
                    :rules="addressRules"
                    label="Address"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="address.city"
                    :rules="cityRules"
                    label="City"
                    solo
                    flat
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="address.postcode"
                    :rules="postcodeRules"
                    label="Postcode"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" md="6" @click.stop>
                  <v-select
                    v-model="address.countryId"
                    :items="countries"
                    :rules="countryRules"
                    label="Country"
                    solo
                    flat
                    dense
                    value
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.aptNo"
                    :rules="aptNoRules"
                    label="Building No"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.state"
                    :rules="stateRules"
                    label="State"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="appGreen darken-1" dark type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="showInviteModal" width="800">
      <v-form ref="InvitationForm" @submit.prevent="inviteUser">
        <v-card>
          <v-card-title>
            <span class="headline ml-3">Invite New Members</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.email"
                    label="Email"
                    type="email"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.firstName"
                    label="First name"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.lastName"
                    label="Last name"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="user.gdcNumber"
                    label="Gdc number"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-select
                    v-model="user.userPositionId"
                    :items="userPositions"
                    label="User position"
                    solo
                    flat
                    dense
                    value
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                  ></v-select>
                </v-col>
              </v-row>
              <v-btn color="appGreen" type="submit" class="white--text"
                >Invite</v-btn
              >
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </v-form>
</template>

<script>


 


import { mapState } from "vuex";

export default {
  name: "CompanyInfoComponent",
  components: {},
  filters: {
    formattedAddress: function(address) {
      let formatted = `${address.aptNo} ${address.address}, ${address.city}, ${address.postcode}, ${address.country.name}`;
      return formatted.length > 75
        ? `${formatted.substring(0, 75)}...`
        : formatted;
    }
  },
  data: () => ({
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    showAddModal: false,
    showEditModal: false,
    showInviteModal: false,
    // invite: {
    //   firstNameRules: [
    //     v => !!v || "Name is required",
    //     v => v.length >= 3 || "Name must be at least 3 characters",
    //     v => v.length <= 35 || "Name must be less than than 35 characters"
    //   ],
    //   lastNameRules: [
    //     v => !!v || "Name is required",
    //     v => v.length >= 3 || "Name must be at least 3 characters",
    //     v => v.length <= 35 || "Name must be less than than 35 characters"
    //   ],
    //   emailRules: [
    //     v => !!v || "E-mail is required",
    //     v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    //   ],
    //   gdcNumberRules: [
    //     v => !!v || "GdcNumber is required",
    //     v => v.length >= 8 || "GdcNumber must be at least 8 digits",
    //     v => v.length <= 10 || "GdcNumber must be less than than 10 digits"
    //   ],
    //   userPositionIdRules: [v => !!v || "User position is required"]
    // },
    addressRules: [
      v => !!v || "Address is required",
      v => (v && v.length >= 4) || "Address must be at least 4 characters",
      v =>
        (v && v.length <= 100) ||
        "Address must be less than than 100 characters"
    ],
    cityRules: [
      v => !!v || "City is required",
      v => (v && v.length >= 3) || "City must be at least 3 characters",
      v => (v && v.length <= 35) || "City must be less than than 35 characters"
    ],
    postcodeRules: [
      v => !!v || "Postcode is required",
      v => (v && v.length >= 3) || "Postcode must be at least 3 characters",
      v =>
        (v && v.length <= 10) || "Postcode must be less than than 10 characters"
    ],
    countryRules: [v => !!v || "Country is required"],
    aptNoRules: [v => !!v || "Apt no is required"],
    stateRules: [
      v => !!v || "State is required",
      v => (v && v.length >= 3) || "State must be at least 3 characters",
      v => (v && v.length <= 25) || "State must be less than than 25 characters"
    ],
    surgeryRules: {
      address: [
        v => !!v || "Address is required",
        v => (v && v.length >= 8) || "Address must be at least 8 characters",
        v =>
          (v && v.length <= 100) ||
          "Address must be less than than 100 characters"
      ],
      aptNo: [v => !!v || "AptNo is required"],
      name: [
        v => !!v || "name is required",
        v => (v && v.length >= 4) || "name must be at least 4 characters",
        v =>
          (v && v.length <= 35) || "name must be less than than 35 characters"
      ],
      phone: [
        v => !!v || "phone is required",
        v => (v && v.length >= 8) || "phone must be at least 8 characters",
        v =>
          (v && v.length <= 20) || "phone must be less than than 20 characters"
      ],
      state: [
        v => !!v || "state is required",
        v => (v && v.length >= 4) || "state must be at least 4 characters",
        v =>
          (v && v.length <= 25) || "state must be less than than 25 characters"
      ],
      postcode: [
        v => !!v || "postcode is required",
        v => (v && v.length >= 5) || "postcode must be at least 5 characters",
        v =>
          (v && v.length <= 10) ||
          "postcode must be less than than 10 characters"
      ],
      city: [
        v => !!v || "city is required",
        v => (v && v.length >= 3) || "city must be at least 3 characters",
        v =>
          (v && v.length <= 35) || "city must be less than than 35 characters"
      ],
      countryId: [v => !!v || "country is required"]
    }
  }),
  mounted() {
    
    

    this.$store.dispatch("user/GET_USER", this.user.uid);

    this.$store.dispatch("surgery/LOAD_SURGERY");
    this.$store.dispatch("surgery/GET_SURGERY_ADDRESS");
    this.$store.dispatch("country/GET_COUNTRIES");
    this.$store.dispatch("user/GET_USER_POSITIONS");
  },
  methods: {
    // async inviteUser() {
    //   if (this.$refs.InvitationForm.validate()) {
    //     this.$swal({
    //       title: "Sending invite to user",
    //       html: "this may only take a moment...",
    //       icon: "info"
    //     });
    //     await this.$store.dispatch("surgery/INVITE_USER_TO_SURGER", this.user);
    //     this.$swal({
    //       title: "Success",
    //       html: "User has been invited",
    //       icon: "info"
    //     });
    //   }
    // },
    async destroy(address) {
      let { value } = await this.$swal.fire({
        title: "Delete address",
        html: "Are you sure you want to delete this address",
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No"
      });
      if (value) {
        this.$swal({
          title: "Deleting address ...",
          html: "this may only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("surgery/DELETE_ADDRESS", address);
        this.$swal({
          title: "Success",
          html: "Address has been deleted",
          icon: "info"
        });
        return true;
      }
      return false;
    },
    async editAddress() {
      if (this.$refs.addressEditForm.validate()) {
        this.showEditModal = false;
        this.$swal({
          title: "Updating address",
          html: "This will only take a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("surgery/UPDATE_ADDRESS", this.address);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Address updated successfully",
          icon: "info"
        });
        this.$refs.addressCreateForm.resetValidation();
      }
    },
    async createAddress() {
      if (this.$refs.addressCreateForm.validate()) {
        this.showAddModal = false;
        this.$swal({
          title: "Creating address",
          html: "This will only take a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("surgery/CREATE_ADDRESS", this.address);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Address created successfully",
          icon: "info"
        });
        this.$refs.addressCreateForm.resetValidation();
      }
    },
    openEditModal(address) {
      this.$store.commit("surgery/LOAD_ADDRESS", address);
      this.$forceUpdate();
      this.showEditModal = true;
    },
    async save(address, index) {
      if (this.$refs[index + "-form"][0].validate()) {
        this.$swal({
          title:
            address.id === undefined
              ? "Creating address..."
              : "Updating address",
          html: "this will only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("user/SAVE_ADDRESS", address);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html:
            address.id !== undefined
              ? "Address updated successfully"
              : "Address created successfully",
          icon: "info"
        });
      }
    },
    add() {
      this.showAddModal = true;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating company info",
          html: "this will only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("surgery/SAVE_SURGERY", this.surgery);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Companyinfo updated successfully",
          icon: "info"
        });
      }
    }
  },
  computed: {
    ...mapState({
      addresses: state => state.surgery.addresses,
      address: state => state.surgery.address,
      countries: state => state.country.countries,
      surgery: state => state.surgery.surgery,
      userPositions: state => state.user.userPositions,
      profileUser: state => state.user.user
    }),
    approvedStatus() {
      return this.user.approved ? true : false;
    }
  }
};
</script>
<style lang="scss" src="./CompanyInfo.scss"></style>
<style lang="scss">



.company-info {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }
  .vue-tel-input-vuetify .v-text-field--solo-flat .v-input__slot .v-label {
    top: 10px;
  }
  .vue-tel-input-vuetify .v-text-field--solo-flat .v-input__slot .v-label {
    top: 17px;
    left: 11px !important;
  }
  .country-code .v-input__slot .v-input__append-inner {
    margin-top: 15px !important;
  }
}
</style>
